import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import DescriptionAccordion from '../../components_desktop/components/DescriptionAccordion/DescriptionAccordion';

class ProductDetailsDescriptionGroup extends Component {
  renderAccordion(title, text, idx) {
    const { isDesktop, s3BasePath } = this.props;
    return (
      <DescriptionAccordion
        collapsed={idx}
        margin={isDesktop ? '0 0 0 0' : '3% 5%'}
        s3BasePath={s3BasePath}
        text={text}
        title={title}
        isDesktop={isDesktop}
      />
    );
  }

  render() {
    const { data } = this.props;
    return <Fragment>{data.map((el, idx) => this.renderAccordion(el.title, el.text, idx))}</Fragment>;
  }
}

ProductDetailsDescriptionGroup.propTypes = {
  isDesktop: PropTypes.bool,
  s3BasePath: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({ title: PropTypes.string.isRequired, text: PropTypes.string.isRequired }))
};

export default ProductDetailsDescriptionGroup;
